'use strict';

angular
  .module('ClinicApp')
  .controller(
    'ModalOCProCountdownCtrl',
    function($scope, $modalInstance, OpencareConstants, daysLeft) {
      $scope.isOfferEndingToday = daysLeft === 0;
      $scope.offerEndDateDisplay = OpencareConstants.ocProPromotionPeriod.END.format('MMMM Do');
      $scope.formattedDaysLeft = String(daysLeft).padStart(2, '0');

      $scope.close = function() {
        $modalInstance.dismiss('cancel');
      };
    },
  );
